import React, { Suspense } from 'react';
import { Spinner } from "react-bootstrap";

import Belt from '../components/Belt';
import Footer from '../components/Footer';
import AuthService from "../services/auth.service";
import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

const BeltClassNewApp = React.lazy(() => import('../classAppComponents/BeltClassNewApp'));
const TabStudentLesson = React.lazy(() => import('../classAppComponents/TabStudentLesson'));

class PageShowStudentClassPresence extends React.Component {

  state = {
    currentUser: AuthService.getCurrentUser(),
    title: "RezerwujKort.pl - Szkółki tenisowe",
    restStudentData: {
      successful: false,
      status: '',
      message: '',
      data: []
    }
  }

  async fechGetStudent(url) {

    var data;

    data = await FetchGetDataWithAuthNEW(url);
    if (data) {
      this.setState({ restStudentData: data });
    }
  }

  async componentDidMount() {

    var url = "/class_app/" + this.props.match.params.club + "/admin/student/show/" + this.props.match.params.id;

    await this.fechGetStudent(url);
    document.title = this.state.title;
  }

  render() {

    var beltClassApp = <div>
      <Suspense fallback={<div>
        <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
      </div>}>
        <BeltClassNewApp club={this.props.match.params.club} />
      </Suspense>
    </div>

    var tabStudentLesson = <div>
      <Suspense fallback={<div>
        <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
      </div>}>
        <TabStudentLesson
          club={this.props.match.params.club}
          studentId={this.props.match.params.id}
          page="1"
          classId={this.props.match.params.classId} />
      </Suspense>
    </div>

    return (

      <div>
        {beltClassApp}

        <div id="content">
          <div class="container">

            

            <br /><br />
            <b>Szczegóły uczestnika zejęć</b>
            <br /><br />
            Imie: {this.state.restStudentData.data.name}<br />
            Nazwisko: {this.state.restStudentData.data.surname}<br />
            Email: {this.state.restStudentData.data.email}<br />
            Kiedy dodany: {this.state.restStudentData.data.createdAt}<br />
            <br /><br />
            Zajęcia w których zapisany jest uczestnikkk:
            <br /><br />
            {tabStudentLesson}
            <br /><br />
          </div>
        </div>


      </div>
    );
  }
}
export default PageShowStudentClassPresence;
